import React, { IframeHTMLAttributes, useEffect, useState } from 'react';
import './index.css';

const WechatGuide: React.FC<any> = (props) => {
    const { data } = props
    return (
        <div className="wrapWechatGuide">
            <div className='wechatContent'>
                <div className='step'>第一步, 点击右上角的...</div>
                <div className='step'>第二步, 在safari浏览器打开</div>
                <div className='step'>第三步, 打开后保存到桌面即可进入</div>
            </div>
        </div>)
}

export default WechatGuide;
